var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-1.055 -1.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(1.054 1.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M7.3,6.054l3.492-3.492a.883.883,0,0,0-1.247-1.25L6.054,4.8,2.563,1.313a.884.884,0,0,0-1.25,1.25L4.8,6.054,1.313,9.546a.884.884,0,0,0,1.25,1.25L6.054,7.3,9.546,10.8a.884.884,0,0,0,1.25-1.25Z",
    transform: "translate(-1.054 -1.054)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCloseIcon);
export default __webpack_public_path__ + "static/media/blackCloseIcon.752133997ecfecb8d11f19801e6b1257.svg";
export { ForwardRef as ReactComponent };